import { GET } from "../axios/apiService";
import { apiEnv } from "../axios/constant";

const activitySlug = apiEnv === "beta" ? "atx-beta" : "atx";
export const getCallActivityOverview = async ({ userId, query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/overview${userId ? `/${userId}` : ""}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCallActivityBestTimes = async ({ userId, query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/best-times${userId ? `/${userId}` : ""}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getCallActivityNumberPerformance = async ({ userId, query, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/number-performance${userId ? `/${userId}` : ""}${query ? `?${query}` : ""}`;
  return GET(url, options);
};

export const getActivityFilterCountries = async ({ options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/filters/countries`;
  return GET(url, options);
};

export const getActivityFilterTimezones = async ({ countryCode, options }) => {
  const url = `${process.env.REACT_APP_API_BASE_URL_TELEPHONY}/${activitySlug}/api/activity/filters/timezones/${countryCode}`;
  return GET(url, options);
};
